"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._LeadFormMappings = exports._LeadFormButtons = void 0;
var translation_1 = __importDefault(require("@services/translation"));
exports._LeadFormButtons = {
    submitButton: { id: '#Membership-Submit' },
    webflowSubmitButton: { id: '#step2' },
};
exports._LeadFormMappings = {
    firstname: {
        id: '#Vorname',
        uid: 'customer.firstname',
        required: true,
        localStorageKey: 'Vorname',
        regex: /^\D{2,}$/, // at least 5 numbers 0-9
        regexError: translation_1.default.t('noValidFirstname'),
    },
    lastname: {
        id: '#Nachname',
        uid: 'customer.lastname',
        required: true,
        localStorageKey: 'Nachname',
        regex: /^\D{2,}$/, // at least 5 numbers 0-9
        regexError: translation_1.default.t('noValidLastname'),
    },
    gender: {
        id: 'input[name="gender"]:checked',
        uid: 'customer.gender',
        localStorageKey: 'Geschlecht',
        regexError: translation_1.default.t('noValidGender'),
    },
    email: {
        id: '#email',
        uid: 'customer.email',
        required: true,
        localStorageKey: 'E-Mail',
        regex: /^(?!.*\.\.)[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
        regexError: translation_1.default.t('noValidEmail'),
    },
    phone: {
        id: '#telefon',
        uid: 'customer.telephone_mobile',
        required: true,
        localStorageKey: 'Telefon',
        regex: /^\d{5,}$/, // at least 5 numbers 0-9
        regexError: translation_1.default.t('noValidPhoneNumber'),
    },
    checkbox: {
        id: '#Checkbox-Lead',
        required: true,
        localStorageKey: 'GDPR',
        type: 'checkbox',
    },
};
